<template>
  <vue-slick-carousel class="" v-if="image?.length > 0" v-bind="slickOptions">
    <div v-for="(item, index) in image" :key="index">
      <div class="image-container">
        <img
          @error="handleImageError()"
          class="image"
          :src="item"
          :alt="item"
        />
      </div>
    </div>
  </vue-slick-carousel>
  <!-- <el-carousel
      class="carousel-banner-home"
      height="250px"
      :autoplay="false"
      :interval="5000"
      type="card"
      arrow="always"
      indicator-position="outside"
      v-if="image?.length > 0"
    >
      <el-carousel-item v-for="(item, index) in image" :key="index">
        <img
          @error="handleImageError()"
          class="image"
          :src="item"
          :alt="item"
        />
      </el-carousel-item>
    </el-carousel> -->
</template>

<script>
import { getBackGround } from "@/utils/wapAuth";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
  bodyClass: "card-facilities",
  components: {
    VueSlickCarousel
  },
  props: {
    image: {
      type: Array,
      default: () => {
        return [
          "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png",
          "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png",
          "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png",
          "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png"
        ];
      }
    }
  },
  watch: {
    objectData(val) {}
  },
  data() {
    return {
      bg: getBackGround(),
      type: null,
      iconStart1: require("@/assets/img/v3/icon/icon_star_1.svg"),
      iconStart: require("@/assets/img/v3/icon/icon_star.svg"),
      icons: {},
      slickOptions: {
        dotsClass: "slick-dots custom-dot-class",
        dots: true,
        arrows: false,
        autoplaySpeed: 2000,
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: false
            }
          }
        ]
      }
    };
  },
  computed: {},
  methods: {
    handleImageError() {
      return "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png";
    }
  }
};
</script>
<style lang="scss">
.custom-dot-class {
  li {
    margin: 0;
    width: 15px;
    height: 15px;
  }
  li.slick-active button:before {
    opacity: 1;
    color: v-bind("bg.c_inherit_text") !important;
  }
  li button:before {
    opacity: 1;
    font-size: 8px;
    color: #00000033;
    width: 10px;
    height: 10px;
  }
}
</style>

<style scoped>
.mr-10 {
  margin-right: 10px;
}

.full-width {
  width: 100%;
}

.image-container {
  position: relative;
  height: 100%;
  height: 173px;
}

.image {
  user-drag: none; /* Safari */
  -webkit-user-drag: none; /* Chrome, Safari, Edge */
  -moz-user-select: none; /* Firefox */
  user-select: none; /* Ngăn chọn ảnh */
  pointer-events: auto; /* Vẫn cho click */
  width: 100% !important;
  height: 100% !important;
  border-radius: 8px;

  object-fit: cover;
  object-position: center;
}

.mb-0 {
  margin-bottom: 0;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
}
</style>
